<template>
  <div class="body">
    <!-- 付款后的订单 -->
    <baseBreadcrumb :page="$t('message.customerAfterPaymentOrder')" :menu="$t('message.orderForm')" />
    <div class="search">
      <div class="operationContainer">

        <!--   订单号-->
        <div class="item">
          <el-input v-model="datas.order_sn" :placeholder="$t('message.orderNumber')" class="Container"
            onfocus="this.select()" />
        </div>
        <!-- 客户ID-->
        <div class="item">
          <el-input v-model="datas.user_id" :placeholder="$t('message.clientID')" class="Container"
            onfocus="this.select()" />
        </div>
        <!--   交易号-->
        <div class="item">
          <el-input v-model="datas.purchase_no" :placeholder="$t('message.transactionNumber')" class="Container"
            onfocus="this.select()" />
        </div>
        <!-- 物流号-->
        <div class="item">
          <el-input v-model="datas.express_no" :placeholder="$t('message.logisticsNumber')" class="Container"
            onfocus="this.select()" />
        </div>
        <!-- 采购 -->
        <div class="item">
          <el-select v-model="datas.g_id" clearable filterable :placeholder="$t('message.buyer')">
            <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!-- 业务 -->
        <div class="item">
          <el-select v-model="datas.y_id" clearable filterable :placeholder="$t('message.salesman')">
            <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!-- 配货员 -->
        <div class="item">
          <el-select v-model="datas.p_id" clearable filterable :placeholder="$t('message.distributionMember')">
            <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!-- 开始日期-->
        <div class="item">
          <el-date-picker v-model="datas.created_at_start" :placeholder="$t('message.startDate')" class="Container"
            type="datetime" default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <!--  结束日期-->
        <div class="item">
          <el-date-picker v-model="datas.created_at_end" :placeholder="$t('message.dateClosed')" class="Container"
            default-time="['23:59:59']" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <!--人员范围-->
        <div class="item">
          <!--  人员范围-->
          <cascader @setUserList="setUserList" :org_id="datas.org_id" ref="cascader" />
        </div>
        <div class="item">
          <!--  全部人员-->
          <el-select v-model="datas.admin_id" :placeholder="$t('message.allPersonnel')" filterable clearable>
            <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!--  订单状态 -->
        <div class="item">
          <el-select v-model="datas.status" :placeholder="$t('message.orderStatus')">
            <el-option v-for="item in orderStatusList" :key="item.key" :label="item.value" :value="item.key">
            </el-option>
          </el-select>
        </div>
        <!--  订单类别 -->
        <div class="item">
          <el-select v-model="datas.type" :placeholder="$t('message.orderType')">
            <el-option v-for="item in typeList" :key="item.key" :label="item.value" :value="item.key">
            </el-option>
          </el-select>
        </div>
        <div class="item">
          <el-select v-model="datas.attribute" clearable filterable placeholder="SVIP">
            <el-option :label="item.label" :value="item.value" v-for="(item) in vipList" :key="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="item">
          <!--  搜索 -->
          <el-button type="primary" @click="search">{{
            $t("message.search")
          }}</el-button>
          <!--  重置 -->
          <el-button @click="reset">{{ $t("message.reset") }}</el-button>
        </div>
      </div>

      <div class="operationContainer">
        <!-- 订单人员调整 -->
        <div class="rightContainer">
          <!-- '无需获取物流号'-->
          <el-button type="primary" @click="forbidCallbackExpress">{{
            $t("message.noNeedToGetTrackingNumber")
          }}</el-button>
          <!-- 订单调整 -->
          <el-button type="success" @click="showOrderAdjust">{{
            $t("message.orderAdjust")
          }}</el-button>
        </div>
      </div>
    </div>
    <div class="table">
      <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
        :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" @selection-change="handleSelectionChange"
        ref="multipleTable" @cell-click="labelSelection" size="mini" v-if="show">
        <el-table-column align="center" label="NO" width="60">
          <template slot-scope="scope">
            <div class="rowNumber">
              {{ scope.row.rowNumber }}
              <!-- 问题产品 -->
              <router-link :to="'/pre-saleProblem?status=0&order_sn=' + scope.row.order_sn" target="_blank"
                v-if="scope.row.unCompleteProblemGoods" slot="reference" class="wen">问
              </router-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column type="selection" width="60" align="center">
        </el-table-column>
        <!-- <el-table-column type="selection" width="45" align="center">
        </el-table-column> -->
        <!--  客户付款时间-->
        <el-table-column align="center" :label="$t('message.customerPaymentTime')" width="76"
          prop="order_time_node.datetime_pay_confirm">
        </el-table-column>
        <!-- 目标上架时间 -->
        <el-table-column align="center" :label="$t('message.targetLaunchTime')" width="76" prop="target_shelf_time">
        </el-table-column>
        <!--  订单类别-->
        <el-table-column align="center" :label="$t('message.orderType')" width="80">
          <template slot-scope="scope">
            <!-- 国际阿里巴巴订单标识 -->
            <p v-if="scope.row.is_alibaba"><img src="@/assets/icon/alibaba.png" alt="" title="阿里巴巴国际站订单"></p>
            {{ scope.row.type_name }}
          </template>
        </el-table-column>
        <!--  客户属性-->
        <el-table-column align="center" :label="$t('message.customerProperty')" width="80">
          <template slot-scope="scope">
            <attributeName :name="scope.row.user_attribute" />
            <!-- <p :style="{ color: scope.row.user_attribute == '付费会员' ? '#b4272d' : '' }">{{ scope.row.user_attribute }}</p> -->
          </template>
        </el-table-column>
        <!--  订单号-->
        <el-table-column align="center" :label="$t('message.orderNumber')">
          <template slot-scope="scope">
            <!-- 供应商订单标识 -->

            <p v-if="scope.row.order_extend">
              <el-tag size="mini" type="primary" class="primary" effect="dark"
                v-if="scope.row.order_extend.is_supplier_order">供应商订单</el-tag>
            </p>
            <p>
              <!-- 分批付款标记 -->
              <el-popover placement="top-start" trigger="hover" v-if="scope.row.part_pay_status >= 2">
                <p>{{ scope.row.part_pay_status_name }}</p>
                <span style="vertical-align: middle;" slot="reference"><img src="@/assets/user/stages.png"
                    alt=""></span>
              </el-popover>
              <!-- 手机下单标记 -->
              <span v-if="scope.row.from_tool != 1" style="vertical-align: middle;">
                <img src="@/assets/icon/mobile.png" alt="" style="width: 25px;">
              </span>
              <!-- 无需获取物流号 -->
              <span v-if="scope.row.order_extend" style="vertical-align: middle;">
                <img src="@/assets/icon/noWL.svg" alt="" style="width: 25px;"
                  v-if="scope.row.order_extend.forbid_callback_express == 1">
              </span>
              <router-link :to="'/orderPaymentDetail?order_sn=' + scope.row.order_sn" target="_blank">
                {{ scope.row.order_sn }}</router-link>
            </p>
            <p> <router-link
                :to="'/user/basicInformation?userID=' + scope.row.user.id + '&encryption=' + $md5(scope.row.user.id + '')"
                target="_blank" style="color:#606266 ">
                {{ scope.row.user.realname }}
              </router-link>
              <el-popover placement="top-start" trigger="hover" v-if="scope.row.children_user != null" title="子账号信息">
                <p>{{ $t('message.names') }}:{{ scope.row.children_user.children_username }}</p>
                <p>ID:{{ scope.row.children_user.id }}</p>
                <img src="@/assets/user/children_user.png" alt="" slot="reference" style="vertical-align: middle;">
              </el-popover>
              <img src="@/assets/icon/illegal.png" alt="" slot="reference" style="vertical-align: middle; width: 30px;"
                v-if="scope.row.user.user_tag != false">
            </p>
          </template>
        </el-table-column>
        <!--  操作人员-->
        <el-table-column align="center" :label="$t('message.operator')" width="120">
          <template slot-scope="scope">
            <div class="text-left">
              <!-- 业务员 -->
              <p>
                {{ $t("message.salesman") }}：{{ scope.row.y_admin ? scope.row.y_admin.realname : '' }}
              </p>
              <!-- 配货员 -->
              <p>
                {{ $t("message.distributionMember") }}：{{
                  scope.row.p_admin ? scope.row.p_admin.realname : ''
                }}
              </p>
              <!-- 采购员 -->
              <p>{{ $t("message.buyer") }}：{{ scope.row.g_admin ? scope.row.g_admin.realname : '' }}</p>
            </div>
          </template>
        </el-table-column>
        <!--  订单番数-->
        <el-table-column align="center" :label="$t('message.ordersNumber')" width="80" prop="order_detail_count">
        </el-table-column>
        <!--  品名材质-->
        <el-table-column align="center" :label="$t('message.commodityMaterial')" width="80">
          <template slot-scope="scope">
            <el-button type="success" size="mini">{{ scope.row.materialCount }}/{{ scope.row.order_detail_count
            }}</el-button>
          </template>
        </el-table-column>
        <!--  订单状态-->
        <el-table-column align="center" :label="$t('message.orderStatus')" width="80">
          <template slot-scope="scope">
            <span :style="{ color: getColor('购买中') }">{{ getOrderStatusList(scope.row.status) }}</span>
          </template>
        </el-table-column>
        <!--  业务临时备忘录-->
        <el-table-column align="center" :label="$t('message.businessTemporaryRemarks')" prop="y_remark">
        </el-table-column>
        <!--  采购订单备注-->
        <el-table-column align="center" :label="$t('message.purchaseOrderRemarks')" prop="g_remark">
        </el-table-column>
        <!--  配货订单备注-->
        <el-table-column align="center" :label="$t('message.fulfillmentOrderNotes')" prop="p_remark">
        </el-table-column>
        <!--  订单时间点-->
        <el-table-column align="center" :label="$t('message.orderTime')">
          <template slot-scope="scope">
            <el-popover placement="left" width="400" trigger="click">
              <div style="padding: 0 12px">
                <h6 style="height: 40px; line-height: 40px; margin-bottom: 20px">
                  {{ $t("message.orderTime") }}
                </h6>
                <el-timeline>
                  <el-timeline-item color="#2C96E7" size="large" :timestamp="'订单提出：' + scope.row.created_at">
                  </el-timeline-item>
                  <el-timeline-item color="#2C96E7" size="large"
                    :timestamp="scope.row.order_time_node.datetime_translate ? '订单翻译：' + scope.row.order_time_node.datetime_translate : ''">
                  </el-timeline-item>
                  <el-timeline-item color="#2C96E7" size="large"
                    :timestamp="'订单确认：' + scope.row.order_time_node.datetime_confirm">
                  </el-timeline-item>
                  <el-timeline-item color="#FFA21D" size="large"
                    :timestamp="scope.row.order_time_node.datetime_offer ? '订单报价：' + scope.row.order_time_node.datetime_offer : ''">
                  </el-timeline-item>
                  <el-timeline-item color="#FFA21D " size="large"
                    :timestamp="'客户提交汇款：' + scope.row.order_time_node.datetime_pay_submit">
                  </el-timeline-item>
                  <el-timeline-item color="#FFA21D " size="large"
                    :timestamp="scope.row.order_time_node.datetime_pay_confirm ? '财务确认汇款：' + scope.row.order_time_node.datetime_pay_confirm : '财务确认汇款：'">
                  </el-timeline-item>
                  <el-timeline-item color="#15AD3C " size="large"
                    :timestamp="scope.row.order_time_node.datetime_purchase_complete ? '采购完了：' + scope.row.order_time_node.datetime_purchase_complete : '采购完了：'">
                  </el-timeline-item>
                  <el-timeline-item color="#15AD3C " size="large" :timestamp="scope.row.order_time_node.datetime_up_complete ? '上架完了：' +
                    scope.row.order_time_node.datetime_up_complete : '上架完了：'">
                  </el-timeline-item>
                  <el-timeline-item color="#15AD3C " size="large"
                    :timestamp="scope.row.order_time_node.datetime_delivery_complete ? '出货完了：' + scope.row.order_time_node.datetime_delivery_complete : '出货完了：'">
                  </el-timeline-item>
                </el-timeline>
              </div>
              <el-button type="success" size="mini" class="primary" slot="reference">{{ $t("message.look")
              }}</el-button>
            </el-popover>
          </template>
        </el-table-column>
        <!--  附件下载-->
        <el-table-column align="center" :label="$t('message.attachmentDownload')">
          <template slot-scope="scope">
            <p v-for="(item, index) in scope.row.order_file" :key="index" style="text-align: left;">
              <a :href="item.file" target="_blank" rel="noopener noreferrer" class="a-link" style="text-align: left;">{{
                item.name }}</a>
            </p>
          </template>
        </el-table-column>

        <!--  下载-->
        <el-table-column align="center" :label="$t('message.orderDownload')">
          <template slot-scope="scope">
            <a :href="baseURL + '/client.orderDetailDownload?order_sn=' + scope.row.order_sn">
              <i class="el-icon-sold-out" style="font-size: 25px;"></i></a>
          </template>
        </el-table-column>
        <!--  操作-->
        <el-table-column align="center" :label="$t('message.operation')" width="110">
          <template slot-scope="scope">
            <!--    订单属性编辑-->
            <!-- <p style="margin-bottom: 10px">
              <el-button size="mini" type="success">
                {{ $t("message.orderPropertyEditing") }}
              </el-button>
            </p> -->
            <!-- 订单备注编辑 -->
            <p style="margin-bottom: 10px">
              <el-button size="mini" class="secondary" type="success" @click="showRemark(scope.row)">
                {{ $t("message.orderRemarksEditing") }}
              </el-button>
            </p>

          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paginationContainer">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
        :page-sizes="[100, 50, 20, 10]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 备注 -->
    <el-dialog :title="remarkTitle" :close-on-click-modal="false" :visible.sync="remarkDialogVisible" width="400px"
      center>
      <div class="content">
        <el-input type="textarea" :placeholder="remarkTitle" v-model="remarkData.remark" show-word-limit>
        </el-input>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="remarkDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <el-button type="primary" @click="updateRemark">
          {{ $t("message.ok") }}</el-button>
      </span>
    </el-dialog>


    <!-- 订单调整 -->
    <orderAdjust ref="orderAdjust" />
  </div>
</template>
<script>
import { getColor } from "@/utlis/utlis";
import { vipList } from '@/utlis/options'
import orderAdjust from '@/components/order/components/orderAdjust.vue'
export default {
  components: {
    orderAdjust,
  },
  data() {
    return {
      vipList,
      getColor,
      datas: {
        order_sn: "",
        created_at_start: "",
        created_at_end: "",
        user_id: "",
        status: "付款后订单列表",
        org_id: "",
        work_group: "",
        admin_id: "",
        page: 1,
        pageSize: 100,
        noorderByAttribute: 1,
      },
      userList: [],
      adminOrganization: [],
      total: 0,
      tableData: [],
      selectList: [],
      show: false,
      remarkDialogVisible: false, //订单备注
      remarkTitle: "", //备注标题
      remarkData: {
        order_sn: "",
        remark_type: localStorage.getItem("japanUserRoleStatus"), //工种
        remark: "",
      },
      //   类型
      typeDialogVisible: false,
      typeData: {
        order_sn: "",
        type: "",
      },
      //   订单人员调整
      dialogVisible: false,
      allotVal: {
        order_sn_set: [],
        y_id: "",
        g_id: "",
        p_id: "",
      },
    };
  },
  computed: {
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p;
    },
    g() {
      return this.$store.state.authWorkGroupAdmin.g;
    },
    orderStatusList() {
      let list = [{ key: '付款后订单列表', value: '全部', }]
      this.$store.state.orderStatusList.forEach(item => {
        if (item.key >= 50) {
          list.push(item)
        }
      })
      return list;
    },
    typeList() {
      return this.$store.state.typeList;
    },
  },
  created() {
    this.orderList();
    this.$api.roleApi.getAdminOrganization().then((res) => {
      this.adminOrganization = res.data;
    });
  },
  methods: {
    orderList() {
      this.show = false;
      this.selectList = []
      this.$api.orderApi.orderList(this.datas).then((res) => {
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.show = true;
        console.log(res);
      });
    },
    // 状态
    getOrderStatusList(status) {
      let name = this.orderStatusList.find(item => item.key == status)
      return name.value
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.orderList();
    },
    // 重置
    reset() {
      this.datas = {
        order_sn: "",
        created_at_start: "",
        created_at_end: "",
        user_id: "",
        status: '付款后订单列表',
        org_id: "",
        work_group: "",
        admin_id: "",
        page: 1,
        pageSize: 100,
        purchase_no: '',
        express_no: '',
        y_id: '',
        p_id: '',
        g_id: '',
        type: '',
        noorderByAttribute: 1,
        attribute: ''
      };
      this.$refs.cascader.orgId = [];
      this.orderList();
      this.$forceUpdate();
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.orderList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.orderList();
    },
    // 整个框选择
    labelSelection(row, column) {
      if (column.className == "el-table-column--selection") {
        this.$refs.multipleTable.toggleRowSelection(row);
      }
    },
    handleSelectionChange(val) {
      this.selectList = val;
    },
    // 显示备注
    showRemark(item) {
      this.remarkData.order_sn = item.order_sn;
      if (this.remarkData.remark_type == 1) {
        this.remarkTitle = this.$t("message.businessTemporaryRemarks");
        this.remarkData.remark = item.y_remark;
      } else if (this.remarkData.remark_type == 2) {
        this.remarkTitle = this.$t("message.purchaseOrderRemarks");
        this.remarkData.remark = item.g_remark;
      }
      this.remarkDialogVisible = true;
    },
    // 编辑备注
    updateRemark() {
      this.$api.orderApi.updateRemark(this.remarkData).then((res) => {
        if (res.code != 0) return this.$message.error(res.message);
        this.remarkDialogVisible = false;
        this.orderList();
      });
    },
    // 显示订单类型
    // 显示订单调整
    showOrderAdjust() {
      if (this.selectList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.$refs.orderAdjust.allotVal = {
        order_sn_set: [],
        y_id: this.selectList.length == 1 ? this.selectList[0].y_id : "",
        g_id: this.selectList.length == 1 ? this.selectList[0].g_id : "",
        p_id: this.selectList.length == 1 ? this.selectList[0].p_id : "",
      };

      this.selectList.forEach((item) => {
        this.$refs.orderAdjust.allotVal.order_sn_set.push(item.order_sn);
        this.$refs.orderAdjust.typeData.order_sn.push(item.order_sn);
      });
      this.$refs.orderAdjust.dialogVisible = true;
    },
    // 刷新订单`
    refresh() {
      this.orderList();
    },
    // 无需获取物流号
    forbidCallbackExpress() {
      if (this.selectList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      let datas = {
        order_sn: []
      }
      this.selectList.forEach((item) => {
        datas.order_sn.push(item.order_sn);
      });
      this.$confirm('此操作将禁止自动回调物流号, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$api.orderApi.forbidCallbackExpress(datas).then(res => {
          this.$message.success(res.msg)
          this.orderList();

        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });

    },
    // 分配
    adjustOrderAdmin() {
      this.$api.orderApi.adjustOrderAdmin(this.allotVal).then((res) => {
        this.dialogVisible = false;
        this.orderList();
        this.selectList = [];
      });
    },
    // 人员范围
    setUserList(data) {
      this.userList = data.userList;
      this.datas.org_id = data.id;
      this.datas.admin_id = "";
    },
  },
};
</script>
<style lang='scss' scoped>
/deep/.el-popper {
  padding: 20px !important;
}

/deep/.el-date-editor {
  width: 200px;
}

.table {
  margin: 20px 0;

  .rowNumber {

    width: 100%;
    height: 100%;

    .wen {
      position: absolute;
      top: 5px;
      left: 5px;
      width: 24px;
      height: 24px;
      background: #c60524;
      border-radius: 12px;
      text-align: center;
      line-height: 24px;
      color: #fff;
    }
  }
}

.item {
  margin-right: 20px;
}

.el-select {
  width: 200px;
}

.operationContainer {
  display: flex;
  flex-wrap: wrap;
  margin-top: 0;

  .item {
    margin-bottom: 20px;
  }

  .leftContainer {
    flex: 10;
  }

  .rightContainer {

    flex: 1;
    text-align: right;
  }
}

/deep/.cell {
  padding: 0 3px !important;
}

.content {
  padding: 0 20px;

  /deep/.el-textarea__inner {
    height: 100px;
  }

  /deep/.el-radio {
    margin-bottom: 20px;
  }
}

a {
  color: #b4272d;

  &:hover {
    text-decoration: underline;
  }
}

.allot {
  margin: 0px 20px 20px;

  .el-select {
    width: 100%;
  }
}
</style>